import API from '@/api/path'
import { externalFetch } from '@/api/externalAxios'

const testModule = {
  state: { dataList: [] },
  actions: {
    async fetchData(_, payload) {
      const id = payload
      try {
        const url = `http://localhost:8080${API.getMailPackageList.url(id)}`
        const config = {
          headers: {
            // 'Content-Type': 'application/json',
            // 'X-Requested-With': 'XMLHttpRequest',
            Authorization:
              'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiI4NDJhYzljOS04MjUwLTQ0MTktYTlkYi00MzA1N2ExNGE5NTQiLCJuYW1lIjoiYWRhZCIsImFjY291bnQiOiJhZG1pbiJ9.AxTnXnpFUHLUyuq9SDmzMWcauUz7479T9BNn1vyaELjyG-hD-hWAEUN-ZXVG1H-xw3GuwvxELZjbQd_QuS_YLirmr6tX13WDLU6ozQ4_l4spKi59fNT_Epv4yjLc_WgvFKAqYxBNuHFvRitvfEgi1FkUnXxJFOJHvQZUICVP1YV9xmDD1y7BUD8ySwfTP3Fz_YYOMy0cDZvb2nFuE7Jo2cLJKhhzJsLhT6VE0tvjEhq50hI5IZ3pw0uY0qaNuXgkBV42RM5H6f8v4kjTbWkNluuZv-XzRvRo2u_T6Q2-prJtwxMZiinlxL5TzBQnPZxATv944axyLbaucrWVrFRBVw'
          },
          params: { status: 0 }
        }
        const res = await externalFetch(
          url,
          API.getMailPackageList.method,
          config
        )
        console.log('res: ', res)

        // commit('SET_DATA_LIST', res.data.data)
      } catch (error) {
        console.error('error', error)
      }
    }
  },
  mutations: {},
  getters: {},
  namespaced: true
}

export default testModule
